import React, { useEffect, useState } from "react";
import ClassDocuments from "../ClassDocuments";

export default function TeacherDocuments(props) {
  const [level, setLevel] = useState();

  useEffect(() => {
    setLevel(props.level);
  }, [props.level]);
  const renderLevel = () => {
    switch (level) {
      case "Class":
        return (
          <ClassDocuments
            coursesData={props.coursesData}
            teacherInfo={props.teacherInfo}
            classId={props.classId}
          />
        );
      case "Student":
        return <div>Student</div>;
      case "Program":
        return <div>Program</div>;
      default:
        return <div></div>;
    }
  };

  return <div>{renderLevel()}</div>;
}
